import useSessionStorage from 'Utils/Hooks/useSessionStorage';
import useSession from "Utils/Hooks/useSession";

/**
 * Parses 'amount' query string parameter and caches for the session.
 * @returns {int} current amount
 */
function useTransactionAmount(newAmount) {
  const [transactionAmount, setTransactionAmount] = useSessionStorage('vip-transaction-amount');
  const { session } = useSession();

  if (newAmount && newAmount !== transactionAmount) {
    setTransactionAmount(newAmount);
    return [newAmount, setTransactionAmount];
  }

  return [transactionAmount, setTransactionAmount];
};

export default useTransactionAmount;
